<template>
  <div class="lots-list tab-table p-2">
    <relations-table :exclude-columns="['related_to_customer_uuid', 'related_to_receipt_uuid']"
                     :exclude-search-fields="['related_to_customer_uuid']"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import RelationsTable from "@/modules/relations/RelationsTable";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: relationsMapActions} = createNamespacedHelpers('relations');

  export default {
    name: "RelationsList",
    components: {RelationsTable},
    data() {
      return {}
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      })
    },
    methods: {
      ...relationsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'customer',
        extraFilters: {object_uuid: this.customer.uuid},
        object: this.customer
      })
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .btn-table-actions {
    display: none;
  }
</style>
